import React from "react";
import BaseEdge, { roundTo } from "./BaseEdge";

export default function BezierEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  color,
}) {
  const from = nodeById[edge.from];
  const to = nodeById[edge.to];
  if (!from || !to) return null;

  const src = {
    x: roundTo(from.x + from.width / 2),
    y: roundTo(from.y + from.height / 2),
  };

  const dst = {
    x: roundTo(to.x + to.width / 2),
    y: roundTo(to.y + to.height / 2),
  };

  const dx = dst.x - src.x;
  const dy = dst.y - src.y;

  // Two cubic control points
  const c1 = {
    x: src.x + dx * 0.25,
    y: src.y + dy * 0.1,
  };

  const c2 = {
    x: src.x + dx * 0.75,
    y: dst.y - dy * 0.1,
  };

  const d = `M ${src.x} ${src.y} C ${c1.x} ${c1.y} ${c2.x} ${c2.y} ${dst.x} ${dst.y}`;

  const labelPos = {
    x: (src.x + dst.x) / 2,
    y: (src.y + dst.y) / 2 - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
